import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import './PlatformTransitionCard.scss';

const REDWOOD_SEED_URL = 'https://seed.redwoodvaluation.com';

export default function PlatformTransitionCard({
  primaryHref = REDWOOD_SEED_URL,
  primaryLabel = 'Continue to Redwood Seed',
  secondaryLabel,
  onSecondary,
  className = '',
}) {
  return (
    <section className={`PlatformTransitionCard ${className}`.trim()} aria-label="Platform update">
      <p className="PlatformTransitionCard__eyebrow">Important update</p>
      <h2 className="PlatformTransitionCard__title">Transitioning to Redwood Seed</h2>
      <p className="PlatformTransitionCard__lede">
        Initio Software has transitioned our services to our new platform,
        {' '}
        <strong>Redwood Seed</strong>
        {' '}
        by Redwood Valuation.
      </p>

      <p className="PlatformTransitionCard__section-label">What this means for you</p>

      <div className="PlatformTransitionCard__points">
        <div className="PlatformTransitionCard__point">
          <span className="PlatformTransitionCard__point-label">Past valuations</span>
          <p>
            You can still view your existing valuations here on Initio Software —
            no action needed for historical records.
          </p>
        </div>
        <div className="PlatformTransitionCard__point">
          <span className="PlatformTransitionCard__point-label">Future valuations</span>
          <p>
            Starting now, all new valuation requests will be handled through Redwood Seed.
            To get started, please create an account at
            {' '}
            <a href={REDWOOD_SEED_URL} target="_blank" rel="noopener noreferrer">
              seed.redwoodvaluation.com
            </a>
            {' '}
            and submit your materials there.
          </p>
        </div>
      </div>

      <p className="PlatformTransitionCard__support">
        Questions about the transition? Reach out to
        {' '}
        <a href="mailto:alexander@redwoodvaluation.com">alexander@redwoodvaluation.com</a>
      </p>

      <div className="PlatformTransitionCard__actions">
        {secondaryLabel && onSecondary && (
          <Button className="PlatformTransitionCard__secondary" onClick={onSecondary}>
            {secondaryLabel}
          </Button>
        )}
        <Button
          className="PlatformTransitionCard__primary"
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={() => window.location.assign(primaryHref)}
        >
          {primaryLabel}
        </Button>
      </div>
    </section>
  );
}

PlatformTransitionCard.propTypes = {
  primaryHref: PropTypes.string,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  onSecondary: PropTypes.func,
  className: PropTypes.string,
};

PlatformTransitionCard.defaultProps = {
  primaryHref: REDWOOD_SEED_URL,
  primaryLabel: 'Continue to Redwood Seed',
  secondaryLabel: undefined,
  onSecondary: undefined,
  className: '',
};
